import Login from '@/views/Login.vue';
import SSO from '@/views/SSO.vue';
import oauthCallback from '@/views/OauthCallback.vue';
import Logout from '@/views/Logout.vue';

export default [
  {
    path: '/login',
		name: 'Login',
		components: {
			default: Login,
		},
  },
	{
    path: '/auth/sso',
		name: 'authorizeLogin',
		components: {
			default: SSO,
		},
  },
  {
    path: '/auth/oauth/callback',
		name: 'oauthCallback',
		components: {
			default: oauthCallback,
		},
  },
  // {
  //   path: '/register',
  //   component: () => import(/* webpackChunkName: "register" */ '@/views/Register.vue'),
  // },
  {
    path: '/recoverpassword',
    component: () => import(/* webpackChunkName: "recoverpassword" */ '@/components/RecoverPassword.vue'),
  },
];
